import templateUrl from "emun.invoice/credit-request/credit-request-line-actions.htm";
import directive from "emun.invoice/credit-request/credit-request-line.directive";

export default directive(templateUrl);

